export const CLASS_NAMES = {
  OVERLAY: "js-overlay",
  IS_ACTIVE: "is-active",
} as const;
